import React from "react";

interface IEditModeContext {
  editMode: boolean;
  setEditMode: (editMode: boolean) => void;
}

const defaultState = {
  editMode: false,
  setEditMode: (editMode: boolean) => {}
};

export const EditModeContext = React.createContext<IEditModeContext>(defaultState);

const EditModeProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
    const [editMode, setEditMode] = React.useState(false);

      
    return (
        <EditModeContext.Provider value={{editMode, setEditMode: (editMode: boolean) => setEditMode(editMode)}}>
          {children}
        </EditModeContext.Provider>
      );
};

export default EditModeProvider;